var gUniversalLocaleMissing = [];

function getMissingLocaleItems() {
    "use strict";
    var lHolder = [];
    var lKey;
    for (lKey in gUniversalLocaleMissing) {
        if (gUniversalLocaleMissing.hasOwnProperty(lKey)) {
            console.log(lKey, gUniversalLocaleMissing[lKey]);
        }
    }

    return lHolder;
}
if (typeof exports !== 'undefined') {
    module.exports = getMissingLocaleItems;
}